<template>
	<div v-if="store.isLoading">📡 Laddar avsnittsinformation...</div>
	<div v-else-if="episode" class="flex flex-col gap-6">

		<router-link :to="`/podcasts/${episode.podcast.id}`" class="text-red hover:text-white">
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
				<path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
			</svg>
		</router-link>
		
		<div class="flex flex-col md:flex-row items-start gap-9 border-b pb-9">
			<figure class="w-full md:w-52 rounded-xl overflow-hidden">
				<img :src="episode.podcast.icon" :alt="episode.podcast.name" />
			</figure>
			<div class="flex-1 flex flex-col gap-1 md:gap-2">
				<h3 class="font-semibold leading-tight text-xl md:text-3xl">{{ episode.episode.name }}</h3>
				<p class="text-sm">{{ format(new Date(episode.episode.published), 'yyyy-MM-dd HH:mm') }} • {{ formattedDuration(episode.episode.seconds) }}</p>
				<p class="text-red font-bold text-sm">{{ episode.podcast.name }}</p>
				
				<nav class="flex flex-row gap-3 my-1">
					<PlayButton :episode="episode.episode" />
					<FavouriteButton :podcast="episode.podcast" />
					<CommentButton :episode="episode.episode" />
				</nav>
				
				<p>{{ cleanDescription }}</p>
			</div>
		</div>
		
		<h2 class="font-bold text-xl">Fler avsnitt</h2>
		<ul class="grid grid-cols-1 md:grid-cols-2 gap-6">
			<li v-for="episode in podcast.episodes" :key="episode.linkid" class="flex flex-row gap-3 items-center">
				<EpisodeCard :episode="episode" />
			</li>
		</ul>
	</div>
	
	<div v-else>Kunde inte hitta avsnittet.</div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { usePodcastStore } from '../stores/podcastStore'
import EpisodeCard from '@/components/EpisodeCard.vue'
import PlayButton from '@/components/PlayButton.vue'
import FavouriteButton from '@/components/FavouriteButton.vue'
import CommentButton from '@/components/CommentButton.vue'
import { format } from 'date-fns'

const route = useRoute()
const store = usePodcastStore()

const podcastId = route.params.podcastId
const episodeId = route.params.episodeId

onMounted(async () => {
	// Säkra att den specifika poddens JSON-fil är inladdad i cachen
	await store.fetchPodcastDetails(podcastId)
})

// Hämta det matchande avsnittet från cachen
const episode = computed(() => store.getEpisodeById(episodeId))
const podcast = computed(() => store.getPodcastDetailsById(podcastId))

const cleanDescription = computed(() => {
  const text = episode.value?.episode?.description || ''
  return text.replace(/<\/?[^>]+(>|\$)/g, '') // Tar bort alla HTML-taggar
})

const formattedDuration = computed(() => {
	return (seconds) => {
		if (!seconds) return '0 min'
		
		const hours = Math.floor(seconds / 3600)
		const minutes = Math.floor((seconds % 3600) / 60)

		const parts = []
		if (hours > 0) parts.push(`${hours} tim`)
		if (minutes > 0) parts.push(`${minutes} min`)

		return parts.join(' ') || '0 min'
	}
})
</script>
